import React, { Component } from "react";
import { MdNotifications, MdAccountCircle } from "react-icons/md";

import { DIMENSIONS } from "utils/Dimensions";
import PackName from "./PackName";
import UserMenu from "./UserMenu";
import LeftHoverMenu from "../common/LeftHoverMenu/LeftHoverMenu";
import { observer } from "mobx-react";
import { useContext } from "react";
import { PackStoreContext } from "app/Pack/PackStore";
import { Button } from "@material-ui/core";

import GroupIcon from "@material-ui/icons/Group";
import LockIcon from "@material-ui/icons/Lock";
import SharePopup from "app/Pack/Share/SharePopup";
import styled from "styled-components";
import { getLogoSrc } from "app/common/utils/Logo";

function Header(props) {
  const packStore = useContext(PackStoreContext);
  const config = packStore.appStore.configStore.config;
  return (
    <div
      className="sticky-top d-flex"
      style={{
        height: DIMENSIONS.header1,
        backgroundColor: props.themeColor,
      }}
    >
      {/* <LeftHoverMenu /> */}
      <span className="heading">
        <img
          src={getLogoSrc()}
          onClick={packStore.goToHomePage}
          alt={config?.site?.title || ""}
          style={{
            height: 28,
            marginLeft: 20,
            marginTop: 8,
            cursor: "pointer",
          }}
        />
      </span>
      <PackName
        packName={props.packName}
        changePackName={props.changePackName}
        themeColor={props.themeColor}
        changeThemeColor={props.changeThemeColor}
        icon={props.icon}
        changeIcon={props.changeIcon}
        store={packStore}
      />

      <div
        className="align-self-center d-flex"
        style={{
          textAlign: "center",
          position: "absolute",
          right: 0,
          top: 10,
        }}
      >
        <ShareButton
          variant="contained"
          onClick={(e) => {
            if (packStore?.pack?.is_log_pack == "1") {
              window.appStore.notificationStore.showNotification(
                "Cannot share History/Records pack",
                "error"
              );
            } else {
              packStore.shareStore.handleClick({
                currentTarget: e.target,
              });
            }
          }}
          // size="small"
          endIcon={packStore.shareStore.isShared ? <GroupIcon /> : <LockIcon />}
        >
          Share
        </ShareButton>
        <SharePopup store={packStore.shareStore} />
        <UserMenu packStore={packStore} isScheduleCallonMenuOpened={props.isScheduleCallonMenuOpened ?? false} />
      </div>
    </div>
  );
}

export default observer(Header);

const ShareButton = styled(Button)`
  && {
    margin-right: 10px;
    background-color: white;
    box-shadow: none;
    &:hover {
      box-shadow: none;
    }
  }
`;
